var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileprofile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 112,
    viewBox: "0 0 123 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 72.4166C32 68.7478 33.5804 65.2292 36.3934 62.6349C39.2064 60.0407 43.0218 58.5833 47 58.5833H77C80.9782 58.5833 84.7936 60.0407 87.6066 62.6349C90.4196 65.2292 92 68.7478 92 72.4166C92 74.251 91.2098 76.0103 89.8033 77.3074C88.3968 78.6045 86.4891 79.3333 84.5 79.3333H39.5C37.5109 79.3333 35.6032 78.6045 34.1967 77.3074C32.7902 76.0103 32 74.251 32 72.4166Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 44.75C68.2132 44.75 73.25 40.105 73.25 34.375C73.25 28.645 68.2132 24 62 24C55.7868 24 50.75 28.645 50.75 34.375C50.75 40.105 55.7868 44.75 62 44.75Z",
    stroke: "white",
    strokeWidth: 5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileprofile);
export default __webpack_public_path__ + "static/media/mobileprofile.29f024670a75ed88540d1b8fee02ccf5.svg";
export { ForwardRef as ReactComponent };